// cosmetic only, 
(function () {
    document.querySelectorAll('[data-language-switcher]').forEach(function (root) {
        var toggle = root.querySelector('[data-language-switcher-toggle]');
        var options = root.querySelector('[data-language-switcher-options]');
        if (!toggle || !options) return;

        toggle.addEventListener('click', function (e) {
            e.stopPropagation();
            var isOpen = root.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        document.addEventListener('click', function (e) {
            if (!root.contains(e.target)) {
                root.classList.remove('is-open');
                toggle.setAttribute('aria-expanded', 'false');
            }
        });

        options.querySelectorAll('[data-value]').forEach(function (option) {
            option.addEventListener('click', function () {
                var mainFlag = toggle.querySelector('.language-dropdown-flag');
                var mainLabel = toggle.querySelector('span');

                var optionFlag = option.querySelector('.language-dropdown-flag').cloneNode(true);
                var optionValue = option.dataset.value.toUpperCase();

                var prevFlag = mainFlag.cloneNode(true);
                var prevLabel = document.createElement('span');
                prevLabel.textContent = mainLabel.textContent.trim();

                option.replaceChildren(prevFlag, prevLabel);
                option.dataset.value = mainLabel.textContent.trim().toLowerCase();

                mainFlag.replaceWith(optionFlag);
                mainLabel.textContent = ' ' + optionValue + ' ';

                root.classList.remove('is-open');
                toggle.setAttribute('aria-expanded', 'false');
            });
        });
    });
})();
